import React from 'react';

class FallbackErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
  }

  render() {
    if (this.state.hasError) {
      return <props.component/>;
    }

    return this.props.children;
  }
}

export default FallbackErrorBoundary;
